import { render, staticRenderFns } from "./OrderDetailTable2.vue?vue&type=template&id=f554942a&scoped=true&"
import script from "./OrderDetailTable2.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f554942a",
  null
  
)

export default component.exports